import { defineComponent as _defineComponent } from 'vue'
import { setBlockTracking as _setBlockTracking, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ca81778"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product__subtitle" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { computed, toRefs } from 'vue'
import ArticleScannedDetails from '@/components/article/ArticleScannedDetails.vue'
import CombinationDetailsList from '@components/combinations/CombinationDetailsList.vue'
import { TCombination } from '@/const/types/combination'

interface Props {
  item: TCombination;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CombinationDetailsView',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
  item: TCombination;
};



const { item: combinationItem } = toRefs(props)

const hasCombinations = computed(() => Boolean(combinationItem.value.product && combinationItem.value.product.combinations && combinationItem.value.product.combinations.length > 0))
const hasPackages = computed(() => Boolean(combinationItem.value.product && combinationItem.value.product.packages && combinationItem.value.product.packages.length > 0))
const hasPlacements = computed(() => Boolean(combinationItem.value.aggregatedPlacements && combinationItem.value.aggregatedPlacements.length > 0))


return (_ctx: any,_cache: any) => {
  return _cache[0] || (
    _setBlockTracking(-1),
    _cache[0] = _createVNode(ArticleScannedDetails, {
      "has-packages": _unref(hasPackages),
      "has-combinations": _unref(hasCombinations),
      "has-placements": _unref(hasPlacements),
      packages: props.item.packages,
      combinations: props.item.product.combinations,
      placements: props.item.aggregatedPlacements
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(combinationItem).product.name) + " ", 1),
        _createElementVNode("span", _hoisted_1, [
          _hoisted_2,
          _createTextVNode(" Combination: " + _toDisplayString(_unref(combinationItem).name), 1)
        ])
      ]),
      "details-list": _withCtx(() => [
        _createVNode(CombinationDetailsList, { combination: _unref(combinationItem) }, null, 8, ["combination"])
      ]),
      _: 1
    }, 8, ["has-packages", "has-combinations", "has-placements", "packages", "combinations", "placements"]),
    _setBlockTracking(1),
    _cache[0]
  )
}
}

})